/* eslint-env browser, amd */
(function($) {
    'use strict';

    $('.touchevents .nav-item').on('touchstart', function(e) {
        var $this = $(this);
        e.preventDefault();
        $('.nav-item').removeClass('hover');
        $this.addClass('hover');
    });

    $('.touchevents .main').on('touchstart', function(e) {
        e.preventDefault();
        $('.nav-item').removeClass('hover');
    });

    $('.nav-item').mouseenter(function() {
        var $this = $(this);
        $('.nav-item').removeClass('hover');
        $this.addClass('hover');
    });

    $('.sub-menu').mouseleave(function() {
        $('.nav-item').removeClass('hover');
    });
})(jQuery);



//////////////////
// WEBPACK FOOTER
// ./source/javascript/es5/menu.js
// module id = 11
// module chunks = 0